import { useState } from 'react';

/** The fields of a TanStack Query result that `useLoadError` reads. */
interface LoadState {
  data: unknown;
  error: Error | null;
  isFetching: boolean;
}

/**
 * The error to show for a query that has no data, or null. Refetching a query that has no data clears its error
 * until the refetch settles; while that refetch runs, the last error is returned, so the error state and its retry
 * button (which may hold focus) stay rendered instead of a loading state. Returns null once the query has data.
 */
export function useLoadError(query: LoadState): Error | null {
  const [last, setLast] = useState<Error | null>(null);
  if (query.error !== null && query.error !== last) setLast(query.error);
  if (query.data !== undefined) return null;
  return query.error ?? (query.isFetching ? last : null);
}
